var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('element',[_c('AppBar',{attrs:{"title":_vm.$t('feedbackPage.title')}}),_c('v-container',[_c('FeedbackTable')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }